import React, { createRef, useEffect } from "react";
import Body from "../../components/Body";
import "../../styles/poRequest.scss";
import moment from "moment";
import Table from "../../common/Table";
import { observer } from "mobx-react-lite";
import { AiFillPrinter } from "react-icons/ai";
import LabelText from "../../common/LabelText";
import numberFormat from "../../common/numberFormat";
import addPrecision from "../../common/addPrecision";
import { Helmet } from "react-helmet-async";
import removeCommas from "../../common/removeCommas";
import LetterFooter from "../../components/LetterFooter";
import LetterHeader from "../../components/LetterHeader";
import AppButton from "../../common/AppButton";
import { GiCog } from "react-icons/gi";
import { BiTrash } from "react-icons/bi";
import api from "../../config/api";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { usePDF } from "react-to-pdf";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getOrganizationByid } from "../../stores/OrganizationStore";
import ContractInvoicePdfTemplate from "./ContractInvoicePdfTemplate";
import { getLocations } from "../../stores/LocationStore";

function ContractInvoicePdf() {
  const navigate = useNavigate();
  const location = useLocation();
  const { data: invoice } = location.state;
  console.log(invoice);
  const { data: organization } = useQuery({
    queryFn: () => getOrganizationByid(invoice.contract?.organization),
    queryKey: ["organization"],
  });

  const { data: locations } = useQuery({
    queryFn: () => getLocations(),
    queryKey: ["locations"],
  });

  const { toPDF, targetRef } = usePDF({
    filename: `INV - ${
      invoice?.organizationName || invoice.contract?.organizationName
    } - ${invoice.invoiceID}.pdf`,
    page: {
      format: "letter",
    },
  });

  const contract = {
    organization: invoice.organization || organization,
    invoice_text: invoice.invoice_text || invoice.contract?.invoice_text,
    location: invoice.location[0]?._id
      ? invoice.location?.map((loc) => loc.title)
      : invoice.location?.map(
          (loc) => locations?.find((location) => location._id === loc).title
        ),
  };

  const goHome = () => {
    const { pathname } = location;
    // history.replace(String(pathname).replace("/invoiceToPdf", ""), { data });
  };

  return (
    <div>
      <Helmet>
        <title>{`INV - ${invoice.contract?.organizationName} - ${invoice.invoiceID}`}</title>
      </Helmet>
      <Body
        onBack={goHome}
        back
        title="Invoice"
        topRight={
          <div
            className="d-flex"
            style={{ gap: "0px 0px", alignItems: "center" }}
          >
            <AppButton
              tooltip="Print"
              leftIcon={<AiFillPrinter size={25} />}
              onClick={() => toPDF()}
            />
          </div>
        }
      >
        <br />
        <br />
        <div ref={targetRef}>
          <ContractInvoicePdfTemplate invoice={invoice} contract={contract} />
        </div>
      </Body>
    </div>
  );
}
export default observer(ContractInvoicePdf);
